import React from 'react';
import PremiumQuiz from '../components/PremiumQuiz';

const QUESTIONS = [
  { id: 1, text: "Você sente que sua vida gira em torno de cuidar ou controlar o comportamento de outra pessoa?", options: [
    { label: "Nunca", value: 0 }, { label: "Às vezes", value: 1 }, { label: "Frequentemente", value: 2 }, { label: "Sempre", value: 3 },
  ]},
  { id: 2, text: "Você já mentiu ou encobriu o comportamento de alguém para protegê-lo?", options: [
    { label: "Nunca", value: 0 }, { label: "Raramente", value: 1 }, { label: "Várias vezes", value: 2 }, { label: "Constantemente", value: 3 },
  ]},
  { id: 3, text: "Você se sente responsável pelos problemas ou pelo bem-estar dessa pessoa?", options: [
    { label: "Não me sinto", value: 0 }, { label: "Um pouco", value: 1 }, { label: "Bastante", value: 2 }, { label: "Totalmente responsável", value: 3 },
  ]},
  { id: 4, text: "Você negligencia suas próprias necessidades para cuidar do outro?", options: [
    { label: "Cuido bem de mim", value: 0 }, { label: "Às vezes me esqueço", value: 1 }, { label: "Frequentemente me anulo", value: 2 }, { label: "Sempre me coloco em último", value: 3 },
  ]},
  { id: 5, text: "Você sente raiva, culpa ou ressentimento em relação a essa pessoa?", options: [
    { label: "Não", value: 0 }, { label: "Às vezes", value: 1 }, { label: "Frequentemente", value: 2 }, { label: "Intensamente", value: 3 },
  ]},
  { id: 6, text: "Você tem dificuldade em estabelecer limites claros?", options: [
    { label: "Tenho limites claros", value: 0 }, { label: "Às vezes cedo", value: 1 }, { label: "Quase sempre cedo", value: 2 }, { label: "Não consigo dizer não", value: 3 },
  ]},
  { id: 7, text: "Você sente medo do que pode acontecer se parar de ajudar?", options: [
    { label: "Não tenho medo", value: 0 }, { label: "Um pouco", value: 1 }, { label: "Bastante medo", value: 2 }, { label: "Pânico só de pensar", value: 3 },
  ]},
  { id: 8, text: "A situação do seu familiar já afetou sua saúde física ou emocional?", options: [
    { label: "Não afetou", value: 0 }, { label: "Um pouco", value: 1 }, { label: "Significativamente", value: 2 }, { label: "Gravemente", value: 3 },
  ]},
  { id: 9, text: "Você sente que está sozinho(a) nessa situação?", options: [
    { label: "Tenho apoio", value: 0 }, { label: "Às vezes me sinto só", value: 1 }, { label: "Frequentemente sozinho(a)", value: 2 }, { label: "Completamente isolado(a)", value: 3 },
  ]},
  { id: 10, text: "Você acredita que precisa de apoio para lidar com essa situação?", options: [
    { label: "Estou bem", value: 0 }, { label: "Talvez", value: 1 }, { label: "Sim, preciso", value: 2 }, { label: "Urgentemente", value: 3 },
  ]},
];

const CONFIG = {
  role: 'familiar',
  icon: 'Users',
  accentColor: '#a855f7',
  accentColorAlt: '#c084fc',
  welcomeTitle: 'Entenda o que está acontecendo com você',
  welcomeSubtitle: 'Descubra como a codependência pode estar afetando sua vida e como encontrar equilíbrio',
  ctaText: 'Criar Conta Gratuita',
  disclaimer: 'Este quiz é informativo e não substitui avaliação profissional.',
};

function getResult(score) {
  if (score <= 8) return {
    level: 'leve', iconName: 'ShieldCheck', neonColor: '#22c55e',
    title: 'Impacto Leve',
    headline: 'Você demonstra boa consciência',
    message: 'Você demonstra boa consciência sobre a situação. A U-Clean oferece conteúdo e comunidade para familiares que desejam entender melhor como apoiar sem se perder.',
  };
  if (score <= 18) return {
    level: 'moderado', iconName: 'AlertTriangle', neonColor: '#f59e0b',
    title: 'Sinais de Codependência',
    headline: 'Existe um padrão que precisa de atenção',
    message: 'Seus resultados indicam padrões de codependência. A U-Clean conecta você com grupos de apoio para familiares e ferramentas como a Comunicação Não-Violenta.',
  };
  return {
    level: 'alto', iconName: 'Heart', neonColor: '#ef4444',
    title: 'Você Merece Cuidado',
    headline: 'Você está carregando um peso muito grande',
    message: 'Você não precisa carregar isso sozinho(a). A U-Clean oferece apoio especializado para familiares, incluindo grupos terapêuticos e acompanhamento profissional.',
  };
}

export default function QuizFamiliares() {
  return <PremiumQuiz questions={QUESTIONS} config={CONFIG} getResult={getResult} />;
}
